<template>
	<div class="flex flex-wrap">
		<AddOnHeaderDataProvider class="flex-col-12" :appId="appId" />
		<AccountHeaderDataProvider v-if="credentialsId" class="flex-col-12" :credentialsId="credentialsId" />
		<ContextHeaderDataProvider class="flex-col-12" :elementType="elementType" :placementId="placementId" />
	</div>
</template>

<script>
import AccountHeaderDataProvider from './AccountHeaderDataProvider.vue';
import AddOnHeaderDataProvider from './AddOnHeaderDataProvider.vue';
import ContextHeaderDataProvider from './ContextHeaderDataProvider.vue';

export default {
	name: 'FullAddOnHeader',
	props: {
		appId: { type: Number },
		credentialsId: { type: Number },
		placementId: { type: Number },
		elementType: { type: String, default: 'Button' },
	},
	components: { AddOnHeaderDataProvider, AccountHeaderDataProvider, ContextHeaderDataProvider },
};
</script>

<style lang="scss" scoped></style>
